
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iframe/list",
      function () {
        return require("private-next-pages/iframe/list/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iframe/list"])
      });
    }
  